import { formatStringAsTime } from './dates-utils';

export const ADD_FORMATTED_SALES_START_TIME = (salesStartTime) => {
  const { Hour, Minute } = salesStartTime;
  const formattedTime = formatStringAsTime(Hour, Minute);
  return {
    salesStartTime,
    formattedSalesStartTime: formattedTime,
  };
};